"use strict";
/* globals module */
/**
 * @module commerceProductFilesClient
 * @description  Files Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../../httpApi");
var _1 = require(".././");
var CommerceProductFilesClient = /** @class */ (function () {
    function CommerceProductFilesClient(productFilesRoute, productFilesStreamsClient, productFilesBatchClient, apiClient) {
        this.productFilesRoute = productFilesRoute;
        this.productFilesStreamsClient = productFilesStreamsClient;
        this.productFilesBatchClient = productFilesBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceProductFilesClient.prototype, "routeDefinition", {
        get: function () {
            return this.productFilesRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceProductFilesClient.prototype, "streams", {
        get: function () {
            return this.productFilesStreamsClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceProductFilesClient.prototype, "batch", {
        get: function () {
            return this.productFilesBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of file resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example productFilesClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    CommerceProductFilesClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns requested file resource.
     * @method
     * @param id Product file id which uniquely identifies product resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @returns A promise that is resolved once the get action has been performed.
     * @example productFilesClient.get('<file-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                       // perform error handling here
                   });
    **/
    CommerceProductFilesClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.productFilesRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will remove one or many file resources from the system if successfully completed. Specified file and all its accompanying derived resources will be removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply baasicProductFilesRouteService route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(fileEntry);
     * let uri = params['model'].links('unlink').href;
     * ```
     * @method
     * @param data Product file object.
     * @param options options object.
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example // fileEntry is a file resource previously fetched using get action. The following action will remove the original file resource and all accompanying derived file resources.
                    productFilesRoute.remove(fileEntry)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    CommerceProductFilesClient.prototype.unlink = function (data, options) {
        if (!options) {
            options = {};
        }
        return this.apiClient.delete(this.productFilesRoute.unlink(data, options));
    };
    /**
     * Returns a promise that is resolved once the update file action has been performed; this action will update a file resource if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicProductFilesRouteService` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     ```
     let params = modelMapper.updateParams(fileEntry);
     let uri = params['model'].links('put').href;
     ```
     * @method
     * @param data Product file object that need to be updated in the system.
     * @returns A promise that is resolved once the update file action has been performed.
     * @example // fileEntry is a file resource previously fetched using get action.
                   fileEntry.description = '<description>';
                   productFilesClient.update(fileEntry)
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                           // perform error handling here
                       });
    **/
    CommerceProductFilesClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.update(data));
    };
    /**
     * Returns a promise that is resolved once the link action has been performed; this action links file resource from other modules into the Product Files module (For example: file resources from the Media Vault module can be linked directly into the Product Files module).
     * @method
     * @param data Product file object.
     * @returns A promise that is resolved once the link action has been performed.
     * @example productFilesClient.link(fileObject)
                    .then(function (response, status, headers, config) {
                        // perform success handling here
                    },
                        function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    CommerceProductFilesClient.prototype.link = function (data) {
        return this.apiClient.post(this.routeDefinition.link(), this.routeDefinition.createParams(data));
    };
    var _a, _b, _c, _d;
    CommerceProductFilesClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.CommerceProductFilesRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.CommerceProductFilesStreamsClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.CommerceProductFilesBatchClient)),
        tslib_1.__param(3, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CommerceProductFilesRoute !== "undefined" && _1.CommerceProductFilesRoute) === "function" ? _a : Object, typeof (_b = typeof _1.CommerceProductFilesStreamsClient !== "undefined" && _1.CommerceProductFilesStreamsClient) === "function" ? _b : Object, typeof (_c = typeof _1.CommerceProductFilesBatchClient !== "undefined" && _1.CommerceProductFilesBatchClient) === "function" ? _c : Object, typeof (_d = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _d : Object])
    ], CommerceProductFilesClient);
    return CommerceProductFilesClient;
}());
exports.CommerceProductFilesClient = CommerceProductFilesClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 
